module.exports = __webpack_public_path__ + "static/Rectangle 65-4ac7a92b16af7724ce8b5e2391c0ee8e.png";